// extracted by mini-css-extract-plugin
module.exports = {"badge":"_2arwV5zJ","BadgeIcon":"nDEMJ6KB","BadgeMessage":"_3P5zaptb"};